import React from 'react';
import SearchPage from './SearchPage';

const AdvancedSearchPage = () => {
	return <SearchPage formInit="advanced" />;
};

export default AdvancedSearchPage;
